import './refandiBanner.scss';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import RefandiIcon from '../../../assets/refandi-icon.svg';
import RefandiIconHighlight from '../../../assets/refandi-icon-highlight.svg';
import { FeatureFlag } from '../../../store/featureStore/enums/FeatureFlag';
import { useFeatureFlag } from '../../../store/featureStore/hooks/useFeatureFlag';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import { locator } from '../../../testing/e2e-locator/locator';

export const RefandiBanner = (): JSX.Element => {
  const {
    computed: { primaryColor },
  } = useThemeStore();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const enableHighlight = useFeatureFlag(
    FeatureFlag.ENABLE_REFANDI_COMPONENT_HIGHLIGHT,
  );

  const icon = enableHighlight ? RefandiIconHighlight : RefandiIcon;

  const containerClassName = [
    'banner-container',
    enableHighlight && 'highlight',
  ]
    .filter(Boolean)
    .join(' ');

  const containerStyle = enableHighlight
    ? { backgroundColor: primaryColor }
    : {};

  const buttonStyle = { backgroundColor: primaryColor };

  const navigateToLoanDocuments = (): void => {
    navigate('/loan-documents');
  };

  return (
    <div
      className={containerClassName}
      data-testid={locator.components.refandiBanner.root}
      style={containerStyle}
    >
      <span className="top">
        <img
          data-testid={locator.components.refandiBanner.iconImage}
          src={icon}
        />

        <label data-testid={locator.components.refandiBanner.savingsText}>
          <b>{t('banners.refandi.savingsAmount')}</b>
          <br />
          {t('banners.refandi.estSavings')}
        </label>
      </span>

      <span className="center">
        <label data-testid={locator.components.refandiBanner.titleText}>
          <b>{t('banners.refandi.title')}</b>
          {t('banners.refandi.subtitle')}
        </label>

        <button
          data-testid={locator.components.refandiBanner.actionButton}
          style={buttonStyle}
          type="button"
          onClick={navigateToLoanDocuments}
        >
          {t('banners.refandi.getStarted')}
        </button>
      </span>

      <span className="bottom">
        <label data-testid={locator.components.refandiBanner.disclaimer}>
          {t('banners.refandi.disclaimer')}
        </label>
      </span>
    </div>
  );
};
